import moment from 'moment-mini'

import { Injectable } from '@angular/core'

import { Raffle } from './raffle'

@Injectable()
export class RaffleSerializer {
  fromJson(json: any): Raffle {
    const raffle = {
      ...json
    }

    return raffle
  }

  toJson(raffle: Raffle): any {
    return {
      ...raffle
    }
  }
}
